import { VerbFetch } from '../VerbFetch';

export const postReaction = (params) => {
    const { body, pathsContext } = params;
    const baseUrl = `${pathsContext.serverUrl}/reactions`;
    const options = {
        method: 'POST',
        body
    };
    return VerbFetch(baseUrl, options);
};

export const putReaction = (params) => {
    const { reactionId, body, pathsContext } = params;
    const baseUrl = `${pathsContext.serverUrl}/reactions/${reactionId}`;
    const options = {
        method: 'PUT',
        body
    };
    return VerbFetch(baseUrl, options);
};
